if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput = this.form.querySelector('[name=id]');
        this.submitButton = this.querySelector('[type="submit"]');

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const formData = new FormData(this.form);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then((response) => response.json())
          .then((data) => {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
          });
      }
    }
  );
}

/* ============================
   ANZA VARIANT FAILSAFE
   Keeps hidden variant ID synced to selected option buttons
============================ */
(function () {
  function safeJSON(str) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return null;
    }
  }

  function getSelectedOptionValueIds(productInfoEl) {
    if (!productInfoEl) return [];

    const variantSelects = productInfoEl.querySelector('variant-selects');
    if (!variantSelects) return [];

    return Array.from(
      variantSelects.querySelectorAll('select option[selected], fieldset input:checked')
    )
      .map((el) => el.dataset.optionValueId)
      .filter(Boolean);
  }

  function getSelectedVariantIdFromHtml(doc) {
    const node = doc.querySelector('variant-selects [data-selected-variant]');
    if (!node) return null;

    const variant = safeJSON(node.innerHTML);
    return variant && variant.id ? String(variant.id) : null;
  }

  function syncVariantId(form) {
    if (!form) return Promise.resolve();

    const idInput = form.querySelector('input[name="id"]');
    if (!idInput) return Promise.resolve();

    const productInfoEl =
      form.closest('product-info') ||
      document.querySelector('product-info[id^="MainProduct"]');

    if (!productInfoEl) return Promise.resolve();

    const optionValueIds = getSelectedOptionValueIds(productInfoEl);
    if (!optionValueIds.length) return Promise.resolve();

    const productUrl = productInfoEl.dataset.url || window.location.pathname;
    const requestUrl = `${productUrl}?option_values=${optionValueIds.join(',')}`;

    return fetch(requestUrl, { method: 'GET', headers: { Accept: 'text/html' } })
      .then((response) => response.text())
      .then((htmlText) => {
        const doc = new DOMParser().parseFromString(htmlText, 'text/html');
        const variantId = getSelectedVariantIdFromHtml(doc);
        if (!variantId) return;

        idInput.value = variantId;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));

        if (window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
        }
      })
      .catch((error) => {
        console.error('ANZA variant sync error:', error);
      });
  }

  document.addEventListener(
    'change',
    function (e) {
      const target = e.target;
      if (!target) return;

      if (
        target.matches('variant-selects input[type="radio"]') ||
        target.matches('variant-selects select')
      ) {
        const form =
          target.closest('product-info')?.querySelector('form[action*="/cart/add"]') ||
          document.querySelector('product-info[id^="MainProduct"] form[action*="/cart/add"]');

        syncVariantId(form);
      }
    },
    true
  );

  let anzaSyncingSubmit = false;

  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (!form || !(form instanceof HTMLFormElement)) return;

      const action = (form.getAttribute('action') || '').toLowerCase();
      if (!action.includes('/cart/add')) return;

      if (anzaSyncingSubmit) {
        anzaSyncingSubmit = false;
        return;
      }

      e.preventDefault();
      anzaSyncingSubmit = true;

      syncVariantId(form).finally(() => {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    },
    true
  );
})();